export const CUSTOM_TEMPLATE_TYPE = "custom";
export const CERTIFICATE_TEMPLATE_TYPE = "certificate";
export const QUESTIONNAIRE_TEMPLATE_TYPE = "questionnaire";

export const TEMPLATE_TYPES = [
    CUSTOM_TEMPLATE_TYPE,
    CERTIFICATE_TEMPLATE_TYPE,
    QUESTIONNAIRE_TEMPLATE_TYPE,
];

export const INITIAL_TEMPLATE_MODEL = {
    blocks: [],
    name: "",
    description: "",
    themeRu: "",
    themeEn: "",
    banner: null,
};

export const MAX_BANNER_SIZE = 1 * 1024 * 1024;
export const MAX_BANNER_DIMENSIONS = {
    WIDTH: 1920,
    HEIGHT: 1080,
};
